<div class="header-wrapper container-xl">
  <div class="row no-gutters g-3">
    <div class="col header-border-lg input-group">
      <div class="row">
        <mpro-country-and-region-selector
          [systemRegions]="authResources.regions"
          [systemCountries]="authResources.countries"
          [filters]="dataFilters"
          [doNotShowSubnational]="true"
          [allowMultiSelect]="false"
          (selectionChanged)="onCountryAndRegionChange($event)"
        >
        </mpro-country-and-region-selector>
      </div>
    </div>
    <div class="col header-border-lg input-group">
      <div class="row">
        <div class="freemium-cateogries data-lens">
          <mpro-dropdown
            #freemiumCategoryDropdown
            title="Categories"
            [inputValue]="dataFilters.freemiumCategory.label"
          >
            <div
              class="scrollable"
              *ngIf="authService.permissions$ | async as plan"
            >
              <ng-container
                *ngFor="let c of categoryService.getMainCategories() | async"
              >
                <mpro-dropdown
                  #dropdowns
                  blockOnClickEvent
                  [condition]="plan.freemiumCategory !== c.code && !!c.code"
                  [requestCategory]="'Category - ' + c.label"
                  [callback]="authService.openFreemiumRequestModal"
                  [title]="c.label"
                  [horizontal]="true"
                  [showArrow]="!!c.code"
                  [showLock]="plan.freemiumCategory !== c.code && !!c.code"
                  (onDropdownClick)="
                    onFreemiumCategoryChange(c, freemiumCategoryDropdown)
                  "
                  (mouseenter)="onCategoryHover(c, dropdowns, true)"
                >
                  <ng-container
                    *ngIf="
                      categoryService.getCategoriesDropdown()
                        | async as category
                    "
                  >
                    <ng-template
                      *ngTemplateOutlet="
                        childCategoryTemplate;
                        context: {
                          plan: plan,
                          dropdowns: dropdowns,
                          categories: category
                        }
                      "
                    >
                    </ng-template>
                  </ng-container>
                </mpro-dropdown>
              </ng-container>
            </div>
          </mpro-dropdown>
        </div>
      </div>
    </div>
    <div class="input-group col">
      <mpro-age-group-selector
        [className]="'row'"
        [inputValue]="dataFilters.ageGroup.displayValue()"
        [userGroups]="customAgeGroups"
        [systemGroups]="authResources.ageGroups"
        (groupClicked)="ageGroupChanged($event)"
        (ageGroupsChanged)="loadRangeCustomFilters()"
      >
      </mpro-age-group-selector>
    </div>
    <div class="col header-border-lg input-group">
      <div class="row">
        <div class="generation data-lens">
          <mpro-dropdown
            #freemiumCategoryDropdown
            title="Generation"
            [inputValue]="'All generations'"
          >
            <ng-container *ngFor="let c of generationsOptions">
              <mpro-dropdown-item
                blockOnClickEvent
                [requestCategory]="'Generation - ' + c.name"
                [leftText]="c.name"
                [showLock]="true"
                [bgColor]="c.value === 0 ? '#8AABFF' : '#FFFFFF'"
                [bgColorHover]="c.value !== 0 ? getHoverColor() : '#8AABFF'"
                [condition]="true"
                [callback]="authService.openFreemiumRequestModal"
              >
              </mpro-dropdown-item>
            </ng-container>
          </mpro-dropdown>
        </div>
      </div>
    </div>
    <div class="input-group col">
      <mpro-static-dropdown
        [attr.title]="'Gender'"
        [className]="'row'"
        class="gender"
        [title]="'Gender'"
        [options]="authResources.genders"
        [inputValue]="
          getNameValuePair(authResources.genders, dataFilters.gender)
        "
        (selectionChanged)="genderChanged($event)"
      >
      </mpro-static-dropdown>
    </div>
    <div class="input-group col">
      <mpro-spending-income-selector
        [className]="'row'"
        [spendingGroups]="
          systemGroupsService.groupedSpendingGroups(
            authResources.spendingGroups
          )
        "
        [inputValue]="dataFilters.spendingGroup.displayValue()"
        [incomeGroups]="authResources.incomeGroups"
        [userSpendingGroups]="customSpendingGroups"
        [userIncomeGroups]="customIncomeGroups"
        [userGroups]="customUserGroups"
        (groupClicked)="spendingGroupChanged($event)"
        (subgroupClicked)="spendingGroupChanged($event)"
        (spendingGroupsChanged)="loadRangeCustomFilters()"
      >
      </mpro-spending-income-selector>
      <span class="spending-group-info-text">Always displayed in 2021 PPP</span>
    </div>
  </div>
  <div class="row no-gutters g-3">
    <div class="col-11 col-md-10 col-lg-5 row g-2 order-2 order-lg-1">
      <mpro-button-group
        class="col-4 col-md-3 col-lg-4"
        title="Demand per"
        [dark]="true"
      >
        <ng-container *ngFor="let b of spendingPer">
          <button
            class="mpro-btn"
            color="blue"
            hue="500"
            *ngIf="!b.hidden"
            mproButtton="secondary"
            [selected]="b.value === dataFilters.spendingPer"
            (click.checkBlockEvent)="onSpendingPerChange(b.value)"
            #exportDataBtn
            blockOnClickEvent
            [condition]="true"
            [callback]="authService.openFreemiumRequestModal"
            [requestCategory]="'Spending per'"
          >
            {{ b.name }}
            <fa-icon
              *ngIf="b.name === 'Year'"
              [icon]="faLock"
              class="lock"
            ></fa-icon>
          </button>
        </ng-container>
      </mpro-button-group>
      <mpro-button-group
        class="col-8 col-md-9 col-lg-8"
        title="Currency View"
        [dark]="true"
      >
        <ng-container *ngFor="let b of currencyView">
          <button
            class="mpro-btn"
            color="blue"
            hue="500"
            mproButtton="secondary"
            [selected]="b.value === dataFilters.currency"
            (click)="onCurrencyViewChange(b.value)"
          >
            {{ b.name }}
          </button>
        </ng-container>
      </mpro-button-group>
      <span class="button-groups-info-text"
        >You're currently looking at
        {{
          dataFilters.currency === 0 ? "2021 PPP USD" : "Nominal Dollars"
        }}.</span
      >
    </div>
    <div class="col-12 col-lg-6 order-1 order-lg-2 g-0">
      <mpro-range-slider
        [min]="startYear"
        [max]="endYear"
        [step]="1"
        [arrows]="false"
        [dragBar]="false"
        [bigCircle]="false"
        [clickableTicks]="true"
        [input]="[dataFilters.year]"
        [labelGap]="labelGap"
        (errorChanged)="onErrorChanged($event)"
        (valueChanged)="sliderChanged($event)"
        [disabledYears]="disabledYears"
        [emitErrorWhenNotAllowed]="true"
        (errorCallback)="handleLockedYearSlider($event)"
        [arrows]="true"
        [customSteps]="(customSteps | async) || []"
      >
      </mpro-range-slider>
    </div>
    <div class="col-1 col-md-2 col-lg-1 text-right order-last">
      <button
        class="mpro-btn mpro-btn-primary reset-button"
        (click)="resetAll()"
        title="Reset Filters"
      >
        <fa-icon [icon]="faUndo"></fa-icon>
        <span>Reset</span>
      </button>
    </div>
  </div>
</div>
<ng-template
  #childCategoryTemplate
  let-plan="plan"
  let-dropdowns="dropdowns"
  let-categories="categories"
>
  <div #childCategories class="subcategories-container">
    <mpro-loading
      class="categories-loader"
      *ngIf="loadingCategories; else categoriesDropdown"
    ></mpro-loading>
    <ng-template #categoriesDropdown>
      <ng-container *ngFor="let c of categories">
        <ng-container
          *ngIf="
            c.childrenSize && c.childrenSize !== 0 && isThirdLevelCategory(c);
            else lastCategory
          "
        >
          <mpro-dropdown
            blockOnClickEvent
            [condition]="true"
            [requestCategory]="getCategoryName(c)"
            [callback]="authService.openFreemiumRequestModal"
            [title]="c.label"
            [horizontal]="true"
            [showArrow]="!!c.code"
            [showLock]="plan.freemiumCategory !== c.code && !!c.code"
            (mouseenter)="onCategoryHover(c, dropdowns, false)"
            [opened]="isChildDropdownOpen(c)"
          >
            <ng-template
              *ngTemplateOutlet="
                childCategoryTemplate;
                context: {
                  plan: plan,
                  dropdowns: dropdowns,
                  categories: c.childrenCategories
                }
              "
            >
            </ng-template>
          </mpro-dropdown>
        </ng-container>
        <ng-template #lastCategory>
          <mpro-dropdown-item
            blockOnClickEvent
            [requestCategory]="getCategoryName(c)"
            [leftText]="c.label"
            [showLock]="true"
            [bgColorHover]="getHoverColor()"
            [condition]="true"
            [callback]="authService.openFreemiumRequestModal"
          >
          </mpro-dropdown-item>
        </ng-template>
      </ng-container>
    </ng-template>
  </div>
</ng-template>
